import {
  Button,
  Container,
  CustomBox,
  InputTextField,
  LoadingSpinner,
} from '@/components';
import { useTranslation } from 'react-i18next';
import { getStockContainerData } from '@/services/getStockContainerData';
import {
  faBoxesStacked,
  faMagnifyingGlass,
} from '@fortawesome/free-solid-svg-icons';
import { useMutation } from '@tanstack/react-query';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import styles from './NumberStock.module.scss';

type QueryType = {
  marca: string;
  numero: string;
};

const NumberStock = () => {
  const {
    data = '',
    mutate,
    isPending,
  } = useMutation({
    mutationFn: getStockContainerData,
  });

  const { t } = useTranslation('numberStock');
  const [value, setValue] = useState('');
  const [query, setQuery] = useState<QueryType>({ marca: '', numero: '' });

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let { value: inputValue } = e.target;
    inputValue = inputValue?.replace(/[^A-Za-z0-9]/g, '');

    if (inputValue?.length > 11) return;

    const marca = inputValue.slice(0, 4);
    const numero = inputValue.slice(4, 11);

    if (marca && !marca.match(/^[A-Za-z]+$/)) return;
    if (numero && !numero.match(/^[0-9]+$/)) return;

    setValue(inputValue?.toUpperCase());
  };

  const onSearch = () => {
    const regex = /^[^\d]*$/;
    if (typeof value !== 'string') return;
    const marca = value.slice(0, 4).toUpperCase();
    const numero = value.slice(4);
    if (numero.length < 7) return;
    if (Number.isNaN(Number(numero))) return;

    if (!regex.test(marca)) return;

    const body = { marca, numero };

    setQuery(body);
    mutate(body);
  };

  return (
    <Container title={t('title')} className={styles.numberStock}>
      <div className={styles.containerSearch}>
        <div className="flex flex-column  md:flex-row col-12 p-0 ">
          <div className="col-12 md: col-12 flex align-items-center pl-0">
            <InputTextField
              className={`col-10 md:col-5 pl-0 ${styles.inputText} `}
              label={t('container')}
              id="container"
              onChange={onInputChange}
              value={value}
              name=""
              placeholder="XXXX1234567"
            />

            <Button
              className={`col-2 md:col-1 ${styles.buttonStock}`}
              onClick={onSearch}
              disabled={value.length < 11}
            >
              <FontAwesomeIcon icon={faMagnifyingGlass} />
              <span className="hidden md:block">{t('consult')}</span>
            </Button>
          </div>
        </div>
        {isPending && (
          <div
            style={{ zIndex: 10, background: 'rgba(0,0,0, 0.2)' }}
            className="absolute top-0 bottom-0 left-0 right-0 z-10 flex align-items-center justify-content-center"
          >
            <LoadingSpinner />
          </div>
        )}
        <div className="flex flex-column md:flex-row col-12 pl-0 pr-0 pb-0 pt-3 ">
          <div className="col-12 md:col-6  pl-0 pr-0 ">
            <CustomBox
              label={`${t('numberConatiner')} ${query?.marca}${query?.numero}`}
              icon={<FontAwesomeIcon icon={faBoxesStacked} size="xl" />}
              iconColor="#223466"
              description={data}
              backgroundColor="rgba(71, 128, 191, 0.1)"
            />
          </div>
        </div>
      </div>
    </Container>
  );
};

export default NumberStock;
